import React, { Component, Fragment } from 'react';
import { Spin, message, Form, Input, notification, Select } from 'antd';
import _ from 'lodash';
import $ from 'jquery';

import './styles.module.scss';
import AppHelper from 'libs/AppHelper';
import { genFormItemAtrribute } from 'libs/FormHelper';
import { API_HOST } from '../../configs/env';
import whttp from '../../libs/whttp';

const VC_CONFIG = _.get(window, 'VC_CONFIG', {});
const PLUGIN_ASSETS_URL = _.get(window, 'VC_CONFIG.PLUGIN_ASSETS_URL');

const stringToBr = (text) => {
  return _.map(_.split(text, '\n'), (line, idx) => (
    <Fragment key={idx}>
      {line}
      <br />
    </Fragment>
  ));
};

// 前端頁面
export default class CIBCInfo extends Component {
  formRef = React.createRef();
  state = {
    query: {},
    storeInfo: undefined,
    listInfo: {
      current: 1, //目前頁數
      page_size: 10, //一頁幾筆
      total: 1, //以此query條件，總共幾筆資料
      rows: [],
    },
    store: [],
    area: null,
    branch: [],
    loading: false,
  };

  componentDidMount() {
    const query = {
      page_size: 'all',
      //iscibc:1
    };
    this.loadConfig();
    this.loadData(query);
    this.setState({
      query,
    });
  }

  fillData = () => {
    this.formRef.current.setFieldsValue({
      phone: '123456',
      name: 'KK',
      licence: ['壽險', '產險', '外幣'],
      area: '北區',
      store: '新店店',
      city: '台北市',
      email: 'test@gamil.xxx',
      desc: '123test',
    });
  };

  loadConfig = () => {
    this.setState({ isLoadingData: true });

    whttp.get(API_HOST + '/api/v1/system/configs', {}, (state, res) => {
      this.setState({ isLoadingData: false });
      const { code = 100, reason = '發生錯誤', data = {} } = res;

      if (state === false) {
        return this.setState({ message: '發生錯誤' });
      }

      if (code !== 200) {
        return this.setState({ message: reason });
      }

      this.setState({ options: data.options }, () => {
        this.refreshPicker();
      });
    });
  };

  loadData = (query) => {
    this.setState({ isFetchData: true });

    whttp.sharedGet(API_HOST + `/api/v1/stores`, query, (state, res) => {
      this.setState({ isFetchData: false });

      const { code = 100, reason = '發生錯誤', data = {} } = res;

      console.log(code, reason, data, res);

      if (state === false || code !== 200) {
        message.warning(reason);
        this.props.history.replace('/cecservice');
        return;
      }

      this.setState({ listInfo: data });
    });
  };
  refreshPicker = _.debounce(() => {
    $('.selectpicker').selectpicker('refresh');
  }, 1000);

  submitData = (info = {}) => {
    info.type = 1;
    /*
        type:
        1:聯絡我們
        2:人才招募
    */
    console.log('submitData', info);

    this.setState({ isSubmitData: true, messages: {} });
    this.setState({ loading: true });

    whttp.post(API_HOST + `/api/v1/cibc/mail`, info, (state, res) => {
      console.log(state, res);
      this.setState({ loading: false });
      this.setState({ isSubmitData: false });

      const { code = 100, reason = '發生錯誤', data = {} } = res;

      if (state === false) {
        return message.error('發生錯誤');
      }

      if (code !== 200) {
        notification['error']({
          message: '發生錯誤',
          description: reason,
        });

        return this.setState({ messages: data.messages || {} });
      }

      notification['success']({
        message: '成功',
      });
    });
  };

  render() {
    const storeInfo = _.get(this, 'state.listInfo.rows', {});
    const options = _.get(this, 'state.options', {});
    const query = _.get(this, 'state.query', {});
    var branchCity = new Set();
    storeInfo.forEach((item) => {
      if (item.city_name) {
        if (!branchCity.has(item.city_name)) {
          branchCity.add(item.city_name);
        }
      }
    });

    this.refreshPicker();
    return (
      <main class='bg-light'>
        <div class='container'>
          <div class='breadcrumb-wrap py-4 m-0'>
            <nav aria-label='breadcrumb'>
              <ol class='breadcrumb'>
                <li class='breadcrumb-item'>
                  <a href={`${VC_CONFIG.INDEX_URL}`}>首頁</a>
                </li>
                <li class='breadcrumb-item'>
                  <a href={`${VC_CONFIG.INDEX_URL}/cibc`}>保險經紀人</a>
                </li>
                <li class='breadcrumb-item active' aria-current='page'>
                  人才招募
                </li>
              </ol>
            </nav>
          </div>
          <section class='pt-5 pb-0'>
            <div class='basic-tabs-border mb-5'>
              <ul class='nav nav-pills' id='pills-tab'>
                <li class='nav-item'>
                  <a class='nav-link' href={`${VC_CONFIG.INDEX_URL}/cibc`}>
                    首頁
                  </a>
                </li>
                <li class='nav-item'>
                  <a
                    class='nav-link'
                    href={`${VC_CONFIG.INDEX_URL}/cibc-about`}>
                    保險經紀人
                  </a>
                </li>
                <li class='nav-item'>
                  <a
                    class='nav-link'
                    href={`${VC_CONFIG.INDEX_URL}/cibc-service`}>
                    服務項目
                  </a>
                </li>
                <li class='nav-item'>
                  <a
                    class='nav-link'
                    href={`${VC_CONFIG.INDEX_URL}/cibc-product`}>
                    商品資訊
                  </a>
                </li>
                <li class='nav-item'>
                  <a
                    class='nav-link'
                    href={`${VC_CONFIG.INDEX_URL}/cibc-partner`}>
                    合作夥伴
                  </a>
                </li>
                <li class='nav-item'>
                  <a
                    class='nav-link'
                    href={`${VC_CONFIG.INDEX_URL}/cibc-activity`}>
                    活動剪影
                  </a>
                </li>
                <li class='nav-item'>
                  <a
                    class='nav-link'
                    href={`${VC_CONFIG.INDEX_URL}/cibc-servicepoint`}>
                    服務據點
                  </a>
                </li>
                <li class='nav-item'>
                  <a
                    class='nav-link'
                    href={`${VC_CONFIG.INDEX_URL}/cibc-recruit`}>
                    人才招募
                  </a>
                </li>
              </ul>
            </div>
          </section>
          <img
            class='img-cover'
            src={`${
              VC_CONFIG.INDEX_URL
            }/wp-content/themes/cec/assets/img/cibc/contact-us/cibc_banner.jpg`}
            alt=''
          />
          <Spin spinning={this.state.loading} tip='Sending...' size='large'>
            <Form
              noStyle
              ref={this.formRef}
              name='basic'
              layout='vertical'
              onFinish={(values) => this.submitData(values)}
              onValuesChange={(changedFields, allFields) => {
                //console.log('onValuesChange', changedFields.area),
                //console.log('onValuesChange-this.state', this.state.area)
                if (changedFields.area) {
                  this.formRef.current.setFields([
                    {
                      name: ['store'],
                      value: null,
                      touched: true,
                      validating: false,
                      errors: [],
                    },
                  ])
                  //console.log('onValuesChange-if', changedFields)
                }
              }}>
              <section class='pt-md-5'>
                <h4 class='heading-title justify-content-center'>
                  聯絡我們
                </h4>
                <hr class='border-top border-gray mt-0 mb-4' />
                <h6 class='h6 text-primary text-center mb-5'>
                  如有任何需求或問題，請寄信到：TW_CIBC@uni-prosperity.com.tw
                  或填寫以下表格，將有專人與您連絡
                  <p />
                  【此頁面僅受理保險相關詢問，若您有分店購物相關問題，請改至以下網址留言
                  <a href='https://www.uni-prosperity.com.tw/contact-us/'>
                    https://www.uni-prosperity.com.tw/contact-us/
                  </a>
                  】
                </h6>
                <fieldset class='bg-white p-5'>
                  <div class='row'>
                    <div class='col-md-6'>
                      <div class='form-group mb-4 row align-items-center'>
                        <label
                          class='col-sm-auto col-form-label h6 text-navy text-md-right'
                          for=''>
                          <span class='d-block' style={{ width: '70px' }}>
                            姓名*
                          </span>
                        </label>
                        <div class='col-sm'>
                          <Form.Item
                            {...genFormItemAtrribute('name')}
                            rules={[
                              { required: true, message: '請輸入姓名' },
                            ]}>
                            <Input className='form-control' />
                          </Form.Item>
                        </div>
                      </div>
                    </div>
                    <div class='col-md-6'>
                      <div class='form-group mb-4 row align-items-center'>
                        <label
                          class='col-sm-auto col-form-label h6 text-navy text-md-left'
                          for=''>
                          <span class='d-block' style={{ width: '70px' }}>
                            所在區域
                          </span>
                        </label>
                        <div class='col-sm'>
                          <Form.Item
                            name='area'
                            {...genFormItemAtrribute('area')}
                            rules={[
                              { required: true, message: '請輸入區域' },
                            ]}>
                            <Select
                              placeholder='請選擇區域'
                              onChange={(changedFields, allFields) => {
                                this.store = storeInfo.filter(
                                  (item) =>
                                    item.store_area_name == changedFields,
                                )
                                this.setState({
                                  store: this.store,
                                  area: changedFields,
                                  branch: this.store[0].name,
                                })
                              }}>
                              <Select.Option value={null} disabled>
                                請選擇區域
                              </Select.Option>
                              {_.map(options.store_areas, (item) => (
                                <Select.Option value={item.name}>
                                  {item.name}
                                </Select.Option>
                              ))}
                            </Select>
                          </Form.Item>
                        </div>
                      </div>
                    </div>
                    <div class='col-md-6'>
                      <div class='form-group mb-4 row align-items-center'>
                        <label
                          class='col-sm-auto col-form-label h6 text-navy text-md-right'
                          for=''>
                          <span class='d-block' style={{ width: '70px' }}>
                            手機*
                          </span>
                        </label>
                        <div class='col-sm'>
                          <Form.Item
                            {...genFormItemAtrribute('phone')}
                            rules={[
                              { required: true, message: '請輸入手機' },
                            ]}>
                            <Input className='form-control' />
                          </Form.Item>
                        </div>
                      </div>
                    </div>
                    <div class='col-md-6'>
                      <div class='form-group mb-4 row align-items-center'>
                        <label
                          class='col-sm-auto col-form-label h6 text-navy text-md-left'
                          for=''>
                          <span class='d-block' style={{ width: '70px' }}>
                            臨近分店
                          </span>
                        </label>
                        <div class='col-sm'>
                          <Form.Item
                            {...genFormItemAtrribute('store')}
                            rules={[
                              { required: true, message: '請選擇分店' },
                            ]}>
                            <Select
                              placeholder='請選擇分店'
                              notFoundContent='請先選擇地區'
                              value={_.get(this, 'state.branch', null)}
                              onChange={(changedFields) => {
                                this.setState({ branch: changedFields })
                              }}>
                              {_.map(this.state.store, (item) => (
                                <Select.Option key={item.name}>
                                  {item.name}
                                </Select.Option>
                              ))}
                            </Select>
                          </Form.Item>
                        </div>
                      </div>
                    </div>
                    <div class='col-12'>
                      <div class='form-group mb-4 row align-items-center'>
                        <label
                          class='col-sm-auto col-form-label h6 text-navy text-md-right'
                          for=''>
                          <span class='d-block' style={{ width: '70px' }}>
                            Email
                          </span>
                        </label>
                        <div class='col-sm'>
                          <Form.Item
                            {...genFormItemAtrribute('email')}
                            rules={[
                              { required: true, message: '請輸入email' },
                            ]}>
                            <Input className='form-control' />
                          </Form.Item>
                        </div>
                      </div>
                    </div>
                    <div class='col-12'>
                      <div class='form-group mb-4 row'>
                        <label
                          class='col-sm-auto col-form-label h6 text-navy text-md-right'
                          for=''>
                          <span class='d-block' style={{ width: '70px' }}>
                            信件內容{' '}
                          </span>
                        </label>
                        <div class='col-sm'>
                          <Form.Item
                            {...genFormItemAtrribute('desc')}
                            rules={[
                              { required: true, message: '請輸入信件內容' },
                            ]}>
                            <Input.TextArea rows={5} />
                          </Form.Item>
                        </div>
                      </div>
                    </div>
                  </div>
                </fieldset>
                <div class='row justify-content-center'>
                  <div class='col-6 col-lg-3 mt-5'>
                    <a
                      class='h6 btn btn-block bg-white text-navy rounded-pill px-5 py-4'
                      role='button'
                      href='#'
                      onClick={(e) => {
                        e.preventDefault()
                        this.formRef.current.submit()
                      }}>
                      確定送出
                    </a>
                  </div>
                </div>
              </section>
            </Form>
          </Spin>
          <section class='pt-md-0'>
            <h4 class='heading-title justify-content-center'>我們的駐點</h4>
            <hr class='border-top border-gray mt-0 mb-4' />
            <div class='row'>
              <div class='col-md-6 d-flex align-items-stretch'>
                <div class='card card-storeInfo shadow-0 card-border-width-1 type-1'>
                  <div class='card-body'>
                    <div class='row'>
                      <div class='col-lg-8 mx-auto'>
                        <h5 class='h4 text-center mb-4'>台北辦公室</h5>
                        <ul class='traffic-info-list'>
                          <li>
                            <i class='icon-store_map' />
                            <span>
                              11268 台北市北投區大業路136號5樓
                              <a
                                class='gMap-link'
                                role='button'
                                href='https://goo.gl/maps/7kb51Fb1uwHAxZMGA'
                                target='_blank'
                                rel='noopener noreferrer'>
                                <img
                                  class='ml-3'
                                  src={`${
                                    VC_CONFIG.INDEX_URL
                                  }/wp-content/themes/cec/assets/img/icon/google_map.svg`}
                                  alt=''
                                />
                              </a>
                            </span>
                          </li>
                          <li>
                            {' '}
                            <i class='icon-store_phone' />
                            <span>02-2898-1999</span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class='col-md-6 d-flex align-items-stretch'>
                <div class='card card-storeInfo shadow-0 card-border-width-1 type-1'>
                  <div class='card-body'>
                    <div class='row'>
                      <div class='col-lg-8 mx-auto'>
                        <h5 class='h4 text-center mb-4'>台南辦公室</h5>
                        <ul class='traffic-info-list'>
                          <li>
                            <i class='icon-store_map' />
                            <span>
                              71079 台南市永康區中華二路350號2樓
                              <a
                                class='gMap-link'
                                role='button'
                                href='https://goo.gl/maps/bu9i4ugrnLHyKswL9'
                                target='_blank'
                                rel='noopener noreferrer'>
                                <img
                                  class='ml-3'
                                  src={`${
                                    VC_CONFIG.INDEX_URL
                                  }/wp-content/themes/cec/assets/img/icon/google_map.svg`}
                                  alt=''
                                />
                              </a>
                            </span>
                          </li>
                          <li>
                            {' '}
                            <i class='icon-store_phone' />
                            <span>06-208-3119</span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </main>
    )
  }
}

// 編輯器
export class CIBCInfoEditor extends Component {
  render() {
    return <div className='vu-blocks-editor'>編輯器</div>;
  }
}



// WEBPACK FOOTER //
// ./src/blocks/cibc/cibc-contact-us.js